import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const USER_ENDPOINT = {
  LOGIN: {
    method: EMethod.POST,
    url: "/user/login",
    version: API_VERSION.V1,
  },
  GET_REFRESH_TOKEN: {
    method: EMethod.PATCH,
    url: "/user/refresh-token",
    version: API_VERSION.V1,
  },
  GET_USER: {
    method: EMethod.GET,
    url: "/user",
    version: API_VERSION.V1,
  },
  GET_USERS_BY_PIPELINE: {
    method: EMethod.POST,
    url: "/user/list/pipeline/{pipelineSlug}",
    version: API_VERSION.V1,
  },

  GET_EMPLOYEE_SETTING: {
    method: EMethod.GET,
    url: "/user/employee/setting",
    version: API_VERSION.V1,
  },
  GET_CLIENT_POST: {
    method: EMethod.GET,
    url: "/user/client/post/list",
    version: API_VERSION.V1,
  },
  GET_DEPARTMENT: {
    method: EMethod.GET,
    url: "/user/department/list",
    version: API_VERSION.V1,
  },
  USER_CLIENT_LIST: {
    method: EMethod.POST,
    url: "/user/list/client",
    version: API_VERSION.V1,
  },
  GET_STAFF_BASIC_INFO: {
    method: EMethod.GET,
    url: "/user/staff/basic-information",
    version: API_VERSION.V1,
  },
};
